/* tslint:disable */

declare var Object: any;
export interface EngagementProgramInterface {
  "sfdcId"?: string;
  "CreatedById"?: string;
  "CurrencyIsoCode"?: string;
  "LastModifiedById"?: string;
  "Name"?: string;
  "OwnerId"?: string;
  "ts2__Active__c"?: boolean;
  "ts2__AdditionalBCC__c"?: string;
  "ts2__AdditionalCC__c"?: string;
  "ts2__AdditionalTo__c"?: string;
  "ts2__AttachmentIds__c"?: string;
  "ts2__Bounced__c"?: number;
  "ts2__Clicked__c"?: number;
  "ts2__Control__c"?: string;
  "ts2__CustomTemplate__c"?: string;
  "ts2__Days__c"?: string;
  "ts2__DeferredSendDate__c"?: Date;
  "ts2__Delivered__c"?: number;
  "ts2__EmailBody__c"?: string;
  "ts2__EmailTemplateId__c"?: string;
  "ts2__End_Date__c"?: Date;
  "ts2__Filters__c"?: string;
  "ts2__Last_Blast_Date__c"?: Date;
  "ts2__Opened__c"?: number;
  "ts2__SendingUser__c"?: string;
  "ts2__Start_Date__c"?: Date;
  "ts2__Unsubscribed__c"?: number;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class EngagementProgram implements EngagementProgramInterface {
  "sfdcId": string;
  "CreatedById": string;
  "CurrencyIsoCode": string;
  "LastModifiedById": string;
  "Name": string;
  "OwnerId": string;
  "ts2__Active__c": boolean;
  "ts2__AdditionalBCC__c": string;
  "ts2__AdditionalCC__c": string;
  "ts2__AdditionalTo__c": string;
  "ts2__AttachmentIds__c": string;
  "ts2__Bounced__c": number;
  "ts2__Clicked__c": number;
  "ts2__Control__c": string;
  "ts2__CustomTemplate__c": string;
  "ts2__Days__c": string;
  "ts2__DeferredSendDate__c": Date;
  "ts2__Delivered__c": number;
  "ts2__EmailBody__c": string;
  "ts2__EmailTemplateId__c": string;
  "ts2__End_Date__c": Date;
  "ts2__Filters__c": string;
  "ts2__Last_Blast_Date__c": Date;
  "ts2__Opened__c": number;
  "ts2__SendingUser__c": string;
  "ts2__Start_Date__c": Date;
  "ts2__Unsubscribed__c": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: EngagementProgramInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `EngagementProgram`.
   */
  public static getModelName() {
    return "EngagementProgram";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of EngagementProgram for dynamic purposes.
  **/
  public static factory(data: EngagementProgramInterface): EngagementProgram{
    return new EngagementProgram(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'EngagementProgram',
      plural: 'EngagementPrograms',
      path: 'EngagementPrograms',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "ts2__Active__c": {
          name: 'ts2__Active__c',
          type: 'boolean',
          default: false
        },
        "ts2__AdditionalBCC__c": {
          name: 'ts2__AdditionalBCC__c',
          type: 'string'
        },
        "ts2__AdditionalCC__c": {
          name: 'ts2__AdditionalCC__c',
          type: 'string'
        },
        "ts2__AdditionalTo__c": {
          name: 'ts2__AdditionalTo__c',
          type: 'string'
        },
        "ts2__AttachmentIds__c": {
          name: 'ts2__AttachmentIds__c',
          type: 'string'
        },
        "ts2__Bounced__c": {
          name: 'ts2__Bounced__c',
          type: 'number'
        },
        "ts2__Clicked__c": {
          name: 'ts2__Clicked__c',
          type: 'number'
        },
        "ts2__Control__c": {
          name: 'ts2__Control__c',
          type: 'string'
        },
        "ts2__CustomTemplate__c": {
          name: 'ts2__CustomTemplate__c',
          type: 'string'
        },
        "ts2__Days__c": {
          name: 'ts2__Days__c',
          type: 'string'
        },
        "ts2__DeferredSendDate__c": {
          name: 'ts2__DeferredSendDate__c',
          type: 'Date'
        },
        "ts2__Delivered__c": {
          name: 'ts2__Delivered__c',
          type: 'number'
        },
        "ts2__EmailBody__c": {
          name: 'ts2__EmailBody__c',
          type: 'string'
        },
        "ts2__EmailTemplateId__c": {
          name: 'ts2__EmailTemplateId__c',
          type: 'string'
        },
        "ts2__End_Date__c": {
          name: 'ts2__End_Date__c',
          type: 'Date'
        },
        "ts2__Filters__c": {
          name: 'ts2__Filters__c',
          type: 'string'
        },
        "ts2__Last_Blast_Date__c": {
          name: 'ts2__Last_Blast_Date__c',
          type: 'Date'
        },
        "ts2__Opened__c": {
          name: 'ts2__Opened__c',
          type: 'number'
        },
        "ts2__SendingUser__c": {
          name: 'ts2__SendingUser__c',
          type: 'string'
        },
        "ts2__Start_Date__c": {
          name: 'ts2__Start_Date__c',
          type: 'Date'
        },
        "ts2__Unsubscribed__c": {
          name: 'ts2__Unsubscribed__c',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
